export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'SAR'
})

export default formatter

// Usage:
// formatter.format(778587.25)

// Other Approach:
//   (2500).toLocaleString('en-US', {
//   style: 'currency',
//   currency: 'SAR'
// })
